import React from "react";
import {Button, Tooltip} from "antd";
import {EditOutlined} from "@ant-design/icons";

export const EditEmailButton = ({showModal}) => {
	return (
		<Tooltip
			title={<span className='color-white'>Խմբագրել</span>}
		>
			<Button
				size='small'
				onClick={showModal}
			>
				<EditOutlined/>
			</Button>
		</Tooltip>
	)
}